import React from 'react';
import './MethodologySection.css';

interface MethodologyItem {
  title: string;
  description: string;
}

interface ScoreLegendItem {
  range: string;
  label: string;
  className: string;
}

interface MethodologySectionProps {
  title?: string;
  methodologyItems: MethodologyItem[];
  scoreLegend: ScoreLegendItem[];
  className?: string;
}

const MethodologySection: React.FC<MethodologySectionProps> = ({
  title = "Scoring Methodology",
  methodologyItems,
  scoreLegend,
  className = ""
}) => {
  return (
    <section className={`methodology-section ${className}`}>
      <div className="section-container">
        <div className="methodology-content">
          <h2>{title}</h2>
          <div className="methodology-grid">
            {methodologyItems.map((item, index) => (
              <div key={index} className="methodology-item">
                <h4>{item.title}</h4>
                <p>{item.description}</p>
              </div>
            ))}
          </div>
          <div className="score-legend">
            <h4>Score Legend</h4>
            <div className="legend-items">
              {scoreLegend.map((item, index) => (
                <span key={index} className="legend-item">
                  <span className={`legend-dot ${item.className}`}></span>
                  {item.range} {item.label}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MethodologySection;
